import { useMemo } from 'react';

import {
  useIsAMACreationV2Enabled,
  useIsAMAPrivateEnabled,
  useIsCalendarInvitationEnabled,
  useIsNewQuestionNotificationEnabled,
  useIsQuestionsOnlyMode,
} from '../../featureChecks';
import { UseMainUIFeatureSettings, uiFeatureAccessSymbol } from '../../types';

export const useAskMeAnythingEventCreationPageSettings: UseMainUIFeatureSettings<'askMeAnythingEventCreationPage'> = (
  options
) => {
  const askMeAnythingEventCreationPageOverrides = options?.overrides?.askMeAnythingEventCreationPage;

  const isAMACreationV2Enabled = useIsAMACreationV2Enabled();
  const isAMAPrivateEnabled = useIsAMAPrivateEnabled();
  const isQuestionsOnlyMode = useIsQuestionsOnlyMode();
  const isNewQuestionNotificationEnabled = useIsNewQuestionNotificationEnabled();
  const isCalendarInvitationEnabled = useIsCalendarInvitationEnabled();

  return useMemo(() => {
    if (isQuestionsOnlyMode) {
      return {
        [uiFeatureAccessSymbol]: false,
        private: false,
        newQuestionNotification: isNewQuestionNotificationEnabled,
        calendarInvitationToggleEnabled: isCalendarInvitationEnabled,
        ...askMeAnythingEventCreationPageOverrides,
      };
    }

    return {
      [uiFeatureAccessSymbol]: isAMACreationV2Enabled,
      private: isAMAPrivateEnabled,
      newQuestionNotification: isNewQuestionNotificationEnabled,
      calendarInvitationToggleEnabled: isCalendarInvitationEnabled,
      ...askMeAnythingEventCreationPageOverrides,
    };
  }, [
    askMeAnythingEventCreationPageOverrides,
    isAMACreationV2Enabled,
    isAMAPrivateEnabled,
    isNewQuestionNotificationEnabled,
    isCalendarInvitationEnabled,
    isQuestionsOnlyMode,
  ]);
};
